import { render, staticRenderFns } from "./Order_details.vue?vue&type=template&id=5ba633a0"
import script from "./Order_details.vue?vue&type=script&lang=js"
export * from "./Order_details.vue?vue&type=script&lang=js"
import style0 from "./Order_details.vue?vue&type=style&index=0&id=5ba633a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports